// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2IeXv","col":"styles_col__IIn8F","fulfillmentStatus":"styles_fulfillmentStatus__2C_TF","emailCol":"styles_emailCol__ac_G9"};